import React from 'react';
const ProductBenefits = () => {
  return <div className="mb-12" data-id="element-117">
      <h2 className="text-4xl font-bold text-green-600 mb-5" data-id="element-118">
        Is MyoQuell Right for You?
      </h2>
      <p className="mb-5 text-xl leading-relaxed" data-id="element-119">
        MyoQuell may be the solution you've been searching for if you:
      </p>
      <ul className="list-disc pl-8 space-y-3 mb-6 text-xl" data-id="element-120">
        <li className="leading-relaxed" data-id="element-121">
          Have tried pills, creams, or braces without lasting success
        </li>
        <li className="leading-relaxed" data-id="element-122">
          Want to avoid surgery or reduce dependency on oral medications
        </li>
        <li className="leading-relaxed" data-id="element-123">
          Experience morning stiffness or pain that limits your activities
        </li>
        <li className="leading-relaxed" data-id="element-124">
          Are looking for a natural solution backed by both ancient wisdom and
          modern science
        </li>
        <li className="leading-relaxed" data-id="element-125">
          Want to return to activities you've given up due to knee pain
        </li>
      </ul>
      <div className="bg-gray-50 border border-gray-200 p-8 rounded-lg mb-8" data-id="element-126">
        <h3 className="text-3xl font-bold mb-4" data-id="element-127">A Final Message from Linda</h3>
        <p className="mb-4 italic text-xl leading-relaxed" data-id="element-128">
          "Six months ago, I was researching knee replacement surgery. I'd
          accepted that pain was just going to be part of my life forever.
          Today, I played tag with my granddaughter for an hour. I'm not
          special—if these patches worked for me, they can work for you too.
        </p>
        <p className="italic text-xl leading-relaxed" data-id="element-129">
          Don't wait as long as I did. Don't miss another family gathering,
          another walk with friends, another moment of your life because of knee
          pain. You deserve better, and now there's finally a solution that
          delivers."
        </p>
      </div>
      <div className="flex flex-col md:flex-row gap-8 mb-8" data-id="element-130">
        <div className="md:w-1/2" data-id="element-131">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hvKKg9yb1F1QEUPV7CQnhs/Untitled_design_%282%29.png" alt="MyoQuell Herbal Knee Pain Relief Patches" className="w-full h-auto rounded-lg" data-id="element-132" />
        </div>
        <div className="md:w-1/2" data-id="element-133">
          <h3 className="text-3xl font-bold mb-4" data-id="element-134">How MyoQuell Works</h3>
          <div className="space-y-5" data-id="element-135">
            <div className="flex items-start" data-id="element-136">
              <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-137">
                1
              </div>
              <p className="text-xl leading-relaxed" data-id="element-138">
                <span className="font-bold" data-id="element-139">Apply the patch</span> directly to
                the painful area
              </p>
            </div>
            <div className="flex items-start" data-id="element-140">
              <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-141">
                2
              </div>
              <p className="text-xl leading-relaxed" data-id="element-142">
                <span className="font-bold" data-id="element-143">
                  Advanced transdermal technology
                </span>{' '}
                delivers active ingredients deep into the joint tissue
              </p>
            </div>
            <div className="flex items-start" data-id="element-144">
              <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-145">
                3
              </div>
              <p className="text-xl leading-relaxed" data-id="element-146">
                <span className="font-bold" data-id="element-147">
                  Natural herbs work synergistically
                </span>{' '}
                to reduce inflammation and block pain signals
              </p>
            </div>
            <div className="flex items-start" data-id="element-148">
              <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-149">
                4
              </div>
              <p className="text-xl leading-relaxed" data-id="element-150">
                <span className="font-bold" data-id="element-151">Sustained 8-hour release</span>{' '}
                provides all-day relief without the side effects of oral
                medications
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ProductBenefits;